<section class="bg-white py-10 border-b border-gray-100 dark:bg-shl-navy dark:border-white/5">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <p class="mb-8 text-center text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-widest">
      {{ 'trust_strip.title' | translate }}
    </p>
    <div class="flex flex-wrap items-center justify-center gap-12 md:gap-20 opacity-80">
      <div class="group flex items-center gap-2 grayscale hover:grayscale-0 transition-all duration-300 cursor-default">
        <mat-icon fontSet="material-symbols-outlined" class="text-4xl text-shl-sky">anchor</mat-icon>
        <span class="text-xl font-bold text-gray-700 dark:text-gray-300 group-hover:text-shl-sky">
          {{ 'trust_strip.brand_maritime' | translate }}
        </span>
      </div>
      <div class="group flex items-center gap-2 grayscale hover:grayscale-0 transition-all duration-300 cursor-default">
        <mat-icon fontSet="material-symbols-outlined" class="text-4xl text-blue-600">factory</mat-icon>
        <span class="text-xl font-bold text-gray-700 dark:text-gray-300 group-hover:text-blue-600">
          {{ 'trust_strip.brand_induscorp' | translate }}
        </span>
      </div>
      <div class="group flex items-center gap-2 grayscale hover:grayscale-0 transition-all duration-300 cursor-default">
        <mat-icon fontSet="material-symbols-outlined" class="text-4xl text-green-600">eco</mat-icon>
        <span class="text-xl font-bold text-gray-700 dark:text-gray-300 group-hover:text-green-600">
          {{ 'trust_strip.brand_agrofresh' | translate }}
        </span>
      </div>
      <div class="group flex items-center gap-2 grayscale hover:grayscale-0 transition-all duration-300 cursor-default">
        <mat-icon fontSet="material-symbols-outlined" class="text-4xl text-red-500">medication</mat-icon>
        <span class="text-xl font-bold text-gray-700 dark:text-gray-300 group-hover:text-red-500">
          {{ 'trust_strip.brand_pharmaway' | translate }}
        </span>
      </div>
      <div class="group flex items-center gap-2 grayscale hover:grayscale-0 transition-all duration-300 cursor-default">
        <mat-icon fontSet="material-symbols-outlined" class="text-4xl text-purple-600">
          shopping_bag
        </mat-icon>
        <span class="text-xl font-bold text-gray-700 dark:text-gray-300 group-hover:text-purple-600">
          {{ 'trust_strip.brand_retailgulf' | translate }}
        </span>
      </div>
    </div>
  </div>
</section>
